import React from 'react'

import { PropertyDescription as BasePropertyDescription } from '@guiker/real-estate-components'

import { buildKpiGrid } from './utils'

export const PropertyDescription: React.FC = () => {
  return <BasePropertyDescription kpiGridItems={buildKpiGrid()} />
}
